import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, Branch } from 'ep-bt-field-agent-proxy';
import { BranchAccess, SearchPageNames } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';

@Component({
  selector: 'epbt-fa-bistrackbranches-list',
  templateUrl: './epbt-fa-bistrackbranches-list.component.html',
  styleUrls: ['./epbt-fa-bistrackbranches-list.component.scss']
})
export class EpbtFaBistrackbranchesListComponent implements OnInit {

  private _selectedBisTrackBranch: number;
  @Input('selectedBisTrackBranch') set selectedBisTrackBranch(value: number) {
    this._selectedBisTrackBranch = value;

    if (this._selectedBisTrackBranch) {
      var result = this.bisTrackBranches.filter(x => x.branchID == this._selectedBisTrackBranch);
      this.bisTrackBranchesChange.emit(result ? result[0] : null);
    }
  }
  get selectedBisTrackBranch(): number {
    return this._selectedBisTrackBranch;
  }

  bisTrackBranches: any[] = [];
  pageName = SearchPageNames;
  @Output() bisTrackBranchesChange = new EventEmitter<any>();

  @Input() labelText: string = "Branch*";
  @Input() page: string = "default";

  constructor(private client: FieldAgentClient,
    private faService: EpbtFieldAgentService) { }

  ngOnInit() {
    this.getBisTrackBranches();
  }

  getBisTrackBranches() {
    if (this.faService.bisTrackBranches && this.faService.bisTrackBranches.length != 0) {
      this.bisTrackBranches = this.faService.bisTrackBranches;
      let defaultBranch = this.bisTrackBranches.find(i => i.branchID == -1);
      defaultBranch.name = (this.page == SearchPageNames.CustomerOpportunity || this.page == SearchPageNames.CustomerProductsPurchased || this.page == SearchPageNames.DashboardOpportunitySearch || this.page == SearchPageNames.DashboardWorkOrderSearch) ? "All branches" : "(Select a branch)";
    }
    else {
      this.faService.getWebTrackUser((webTrackUser: any) => {
        this.client.getBisTrackBranches(webTrackUser, BranchAccess.Read).subscribe(res => {
          this.bisTrackBranches = res;
          let defaultBranch = new Branch();
          defaultBranch.branchID = -1;
          defaultBranch.name = (this.page == SearchPageNames.CustomerOpportunity || this.page == SearchPageNames.CustomerProductsPurchased || this.page == SearchPageNames.DashboardOpportunitySearch || this.page == SearchPageNames.DashboardWorkOrderSearch) ? "All branches" : "(Select a branch)";
          this.bisTrackBranches.unshift(defaultBranch);
          this.faService.bisTrackBranches = this.bisTrackBranches;
        });
      });
    }
  }
}
